import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthEndpoint } from '../../api';

const NavbarV3 = () => {

	const [isLogin, setIsLogin] = useState(false);

	useEffect(() => {
		const authEndpoint = new AuthEndpoint();

		const checkSession = async () => {
			try {
				const response = await authEndpoint.verifySession();
				console.log(response);
				setIsLogin(true);
			} catch (error) {
				setIsLogin(false);
			}
		};

		checkSession();
	}, []);

	return (
		<div>
			<header className="ltn__header-area ltn__header-5 ltn__header-logo-and-mobile-menu-in-mobile ltn__header-logo-and-mobile-menu ltn__header-transparent gradient-color-2">

				<div className="ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-black">
					<div className="container">
						<div className="row">
							<div className="col">
								<div className="site-logo-wrap">
									<div className="site-logo go-top">
										<h3 className='text-white'>Smart Kos</h3>
									</div>
								</div>
							</div>
							<div className="col header-menu-column menu-color-white">
								<div className="header-menu d-none d-xl-block go-top">
									<nav>
										<div className="ltn__main-menu">
											<ul>

												<li><Link to="/">Beranda</Link></li>
												<li><Link to="/property-list">Disewakan</Link></li>
												<li className="special-link">
													{isLogin ?
														<li><Link to="/my-account">Akun Saya</Link></li> : 
														<Link to="/login">Masuk</Link>
													}
												</li>
											</ul>
										</div>
									</nav>
								</div>
							</div>
							<div className="col--- ltn__header-options ltn__header-options-2 ">
								{/* Mobile Menu Button */}
								<div className="mobile-menu-toggle d-xl-none">
									<div className="ltn__utilize-toggle">
										<svg viewBox="0 0 800 600">
											<path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top" />
											<path d="M300,320 L540,320" id="middle" />
											<path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) " />
										</svg>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* ltn__header-middle-area end */}
			</header>


		</div>
	)
}

export default NavbarV3